// Module
var code = `<div name="admissions_info_box_desktop"><div translate="lessons.stream.student_dashboard_boxes.content_admissions_info" translate-values="{ admissionsEmail: locales.email, scheduleVideoChatUrl: locales.schedule_video_chat }" translate-compile></div></div>`;
// Exports
export default code;